<template>
  <div class="audiovisual">
    <div class="audiovisualbg">
      <appHeader activeIndex="audiovisual" ></appHeader>
      <div class="audiovisualContent">
        <!-- 介绍 -->
        <div class="audiovisualInfo">
          <div class="audiovisualInfo1">
            <img class="audiovisualInfo1Img1" src="../../assets/img/Product/audiovisual.png"  alt />
            <br><br><br><br><br>
            <!-- <img class="audiovisualInfo1Img2"  src="../../assets/img/products/audiovisual/audiovisualQRcode.png" alt /> -->
            <!-- <div>扫描二维码下载</div>      -->
          </div>
          <div class="audiovisualInfo2">
            <div class="productTitle">
              全能影音播放器
            </div>
            <br>
            一个支持全格式全类型播放的超能APP！
            <br><br>
             <el-divider></el-divider>
             <h2>产品特色</h2>
             <p>【无需转码 即开即看】以下任何格式的：MPEGMPG，DAT，AVI，MOV，ASF，WMV，NAVI，3GP，REAL VIDEO，MKV，FLV，F4V，RMVB，WebM等等，我们都支持播放，即开即看，不需等待，不需转码！</p>
             <p>【流畅播放 拒绝卡顿】无论您的视频是竖版还是横版，我们都支持播放，播放过程非常流畅，支持高清效果，拒绝观看卡顿！</p>
             <p>【音频播放 音乐随听】全能影音播放器同时支持音频格式的播放，无论是音乐还是录音等任何音频格式，您都可以用本款APP播放哦！</p>
             <p>【图片查看 智能操作】全能影音播放器还支持图片的查看功能，让您的美图随时可看，随时可享！</p>
             <p>【智能分享 收藏删除】无论是视频还是音频、图片，都支持该格式的分享、收藏和删除功能，更加人性化，为您提供全方位的服务！</p>
          </div>
          <div style="clear: both;"></div> 
        </div>
        <!-- 第二部分内容 -->
        <el-divider></el-divider>
        <div class="audiovisualCarousel">
          <div class="iconLeft" @click="left"><el-button icon="el-icon-arrow-left" circle></el-button></div>
          <div class="iconRight" @click="right"><el-button icon="el-icon-arrow-right" circle></el-button></div>
          <div class="audiovisualWrap">
            <div class="audiovisualMainImg" :style="{ left: nowLeft + '%' }">
              <img class="audiovisualCarouselImg"   src="../../assets/img/products/audiovisual/carousel.png" alt />
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <appFooter></appFooter>

  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  components: {
    appHeader,appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  mounted() {},
  methods: {
    
      left() {
        
        if(this.nowLeft >= 0){
          return;
        }
        this.nowLeft = this.nowLeft +15
      },

      right() {
        if(this.nowLeft <= -45){
          return;
        }
        this.nowLeft = this.nowLeft -15
      }
  }
};
</script>
<style>
@import "../../assets/css/products/audiovisual.css";
</style>
